import * as React from 'react'
import { FormComponentProps } from 'antd/es/form';
import { Form, Row, Col, Input, Button, Select, DatePicker } from 'antd';
import moment from 'moment'
import _ from "lodash";
import {
  exportCustomOrder,
} from "utils/interface";
import CommonExcelExportBtn from "widget/commonExcelExportBtn";
// 生成唯一的可识别id
// import cuid from "cuid";
// 重写input
import "styles/customOrderListSearchForm.scss";
const { RangePicker } = DatePicker;
const Option = Select.Option;

interface UserFormProps extends FormComponentProps {
  masterList: any;
  page: any;
  customOrderListSearchFormQuery: any;
  goToCreateOrderPage: any;
  statistics: any;
  exportCustomOrderList: any;
  resetQueryParamsAndQuery: any;
  updateExportProcess: any;
}

class CustomOrderListSearchForm extends React.Component<UserFormProps, any> {
  inputDom: Input | null;
  
  constructor(params) {
    super(params);
  }

  _paramsAppend = (params , fieldName , value)=> {
    if(value !== undefined){
      return _.assign(params,{
        [fieldName]: value
      });
    }
    return params;
  }

  _paramsAppendDate = (params, fieldName, value) => {
    if(value && value.length > 0){
      return _.assign(params,{
        ['start_' + fieldName]: value[0].format('YYYY-MM-DD'),
        ['end_' + fieldName]: value[1].format('YYYY-MM-DD')
      });
    }
    return params;
  }

  handleSearch = e => {
    e.preventDefault();
    this.props.form.validateFields((err, values) => {
      if(!err){
        let params = {
          page:this.props.page.current,
          rows:this.props.page.pageSize,
        };
        this._paramsAppend(params, 'number', values.number);
        this._paramsAppend(params, 'customid', values.customid);
        this._paramsAppend(params, 'status', values.status);
        this._paramsAppendDate(params, 'time', values.start_time);
        this._paramsAppendDate(params, 'group', values.start_group);
        this.props.customOrderListSearchFormQuery(params)
      }
    });
  };

  handleReset = () => {
    this.props.form.resetFields();
  };
  
  onChange = (value) => {
  }

  // 遍历数据项
  getData = (data) => {
    let options: any = [];
    if(data && data.length){
      data.forEach((item, index) => {
        // if(isLock){

        // }
        options.push(
          <Option key={index} value={item.id}>
            {item.fullname}
          </Option>
        );
      });
    }
    return options;
  };

  _getExportFilterParams = () => {
    let formValues = this.props.form.getFieldsValue()
    let params = {
      page:this.props.page.current,
      rows:this.props.page.pageSize,
    };
    let formParams = {};
    this._paramsAppend(formParams, 'number', formValues.number);
    this._paramsAppend(formParams, 'customid', formValues.customid);
    this._paramsAppend(formParams, 'status', formValues.status);
    this._paramsAppendDate(formParams, 'time', formValues.start_time);
    this._paramsAppendDate(formParams, 'group', formValues.start_group);
    return {...params, ...formParams};
  }

  render () {
    const { getFieldDecorator } = this.props.form;
    const { statistics } = this.props;
    return (
      <Form className="ant-advanced-search-form" onSubmit={this.handleSearch}>
        <Row gutter={24}>
          <Col span={6} style={{ display:'block'}}>
            <Form.Item>
              {getFieldDecorator(`number`, {
              })(<Input placeholder="定制团号"/>)}
            </Form.Item>
          </Col>
          <Col span={4} style={{ display:'block'}}>
            <Form.Item>
                {getFieldDecorator(`customid`, {})(
                  <Select
                    placeholder={"定制师"}
                    allowClear={true}
                    onChange={this.onChange}
                    // getPopupContainer={this.getContainer}
                    // 检索相关
                    showSearch
                    optionFilterProp="children"
                    dropdownMatchSelectWidth={false}
                    // filterOption={filter}
                  // 检索相关
                  >
                  {this.getData(this.props.masterList)}
                </Select>)}
              </Form.Item>
          </Col>
          <Col span={7} style={{ display:'block'}}>
              <Form.Item>
                  {getFieldDecorator(`start_time`, {})(
                  <RangePicker
                    placeholder={['创建日期', '']}
                    ranges={{
                      Today: [moment(), moment()],
                      'This Month': [moment().startOf('month'), moment().endOf('month')],
                    }}
                    showTime
                    format="YYYY-MM-DD"
                    />
                  )}
              </Form.Item>
          </Col>
          <Col span={7} style={{ display:'block'}}>
              <Form.Item>
                  {getFieldDecorator(`start_group`, {})(
                  <RangePicker
                    placeholder={['出团日期', '']}
                    ranges={{
                      Today: [moment(), moment()],
                      'This Month': [moment().startOf('month'), moment().endOf('month')],
                    }}
                    showTime
                    format="YYYY-MM-DD"
                  />)}
              </Form.Item>
          </Col>
        </Row>
        <Row gutter={24}>
          <Col span={6} style={{ display:'block'}}>
            <Form.Item>
                {getFieldDecorator(`status`, {})(
                  <Select
                    placeholder={"定制状态"}
                    allowClear={true}
                    onChange={this.onChange}
                    // getPopupContainer={this.getContainer}
                    // 检索相关
                    showSearch
                    optionFilterProp="children"
                    dropdownMatchSelectWidth={false}
                    // filterOption={filter}
                  // 检索相关
                  >
                  <Option key={0} value={0}>
                    未成团
                  </Option>
                  <Option key={1} value={1}>
                    已成团
                  </Option>
                </Select>)}
              </Form.Item>
          </Col>
        </Row>
        {/* 第二行 */}
        <Row gutter={24}>
          <Col span={12} style={{ display:'block', }}>
            <Button type="primary" htmlType="submit">
              搜索
            </Button>
            &nbsp;&nbsp;
            <Button type="danger" onClick={()=>{
              this.props.resetQueryParamsAndQuery();
              this.props.form.resetFields();
            }}>
              重置Del
            </Button>
            &nbsp;&nbsp;
            <Button type="primary" onClick={()=>{
              this.props.goToCreateOrderPage();
            }}>
              创建定制单
            </Button>
            &nbsp;&nbsp;
            <CommonExcelExportBtn params={this._getExportFilterParams} requestUrl={exportCustomOrder} >
            </CommonExcelExportBtn>
          </Col>
          <Col span={12} style={{ display:'flex', justifyContent: 'flex-end', alignItems: 'flex-end',height:32}}>
            <div style={{color: '#329FB9'}}>
              { statistics ? `总成本：${statistics.cost} 总退款：${statistics.amount} 总毛利润：${statistics.profit}` : null}
            </div>
          </Col>
        </Row>
      </Form>
    )
  }
}

 

export default Form.create<UserFormProps>({ name: 'custom_order_search' })(CustomOrderListSearchForm); 